import { Link } from 'react-router-dom'
import PolicyPage, { PolicySection, PolicyList } from 'components/compliance/policy-page'
import compliance from 'data/compliance.json'

const { contact, fees } = compliance
const standardServicesAreFree = fees.standardServicesAreFree.value
const publishedPrices = fees.publishedPrices.value

function Fees() {
  return (
    <PolicyPage
      title='Fees and Service Charges'
      description='UHDSS services are free of charge to students. This page explains what that covers, and which costs are set by universities, governments and other organisations.'
      intro='Our services are free of charge to students. This page explains what that covers, and which costs are set by universities, governments and other organisations rather than by us.'
    >
      <PolicySection title={standardServicesAreFree ? 'Services we provide free of charge to students' : 'Our services'}>
        {standardServicesAreFree && (
          <p className='dark-blue fs-6'>
            UHDSS does not charge students a service fee. Our counselling and application support is
            free of charge to you. Depending on availability and on your circumstances, it includes:
          </p>
        )}
        <PolicyList items={fees.freeServices} />
        {fees.commission.receivesInstitutionCommission.value
          && fees.commission.receivesInstitutionCommission.disclosePublicly && (
          <p className='dark-blue fs-6'>
            UHDSS may receive a commission from education institutions that we have a recruitment
            arrangement with. A commission of this kind does not increase the tuition fee that you
            pay, and having a commercial relationship with an institution does not mean that your
            admission, scholarship or visa is guaranteed.
          </p>
        )}
      </PolicySection>

      <PolicySection title={publishedPrices.length > 0 ? 'Services that involve a charge' : 'What we charge students'}>
        {publishedPrices.length > 0 ? (
          <>
            <ul className='dark-blue fs-6'>
              {publishedPrices.map((item, index) => (
                <li className='mb-2' key={index}>
                  <strong>{item.service}</strong> — {item.price}. {item.detail}
                </li>
              ))}
            </ul>
            <p className='dark-blue fs-6'>
              You will never be committed to a paid service by accident. A charge applies only after
              we have explained it to you and you have agreed to it.
            </p>
          </>
        ) : (
          <p className='dark-blue fs-6'>
            Nothing. UHDSS does not charge students a service fee for any of the services listed
            above. There is no price list on this website and no payment or checkout step anywhere
            on it, because our services are free to you.
          </p>
        )}
        <p className='dark-blue fs-6'>
          Application fees are a separate matter. Each university decides whether it charges an
          application fee and how much it is, and that fee is paid to the university or through the
          payment channel it has authorised. It is not a UHDSS charge, and it does not come to us.
        </p>
        <p className='dark-blue fs-6'>
          If anything about a request for money in our name seems unclear or unexpected, please
          check with us first at{' '}
          <a className='text-decoration-none' href={`mailto:${contact.generalEmail}`}>{contact.generalEmail}</a>{' '}
          or on <a className='text-decoration-none' href={`tel:${contact.phone.replace(/\s/g, '')}`}>{contact.phone}</a>.
        </p>
      </PolicySection>

      <PolicySection title='Costs charged by other organisations'>
        <p className='dark-blue fs-6'>
          Studying abroad involves costs that are set and collected by organisations other than
          UHDSS. These are not UHDSS service charges, and we do not control them. They may include:
        </p>
        <PolicyList items={fees.thirdPartyCosts} />
        <p className='dark-blue fs-6'>
          Where we know about a third party cost, we will tell you about it before you have to pay
          it. The organisation that charges it decides its amount, its payment terms and its refund
          rules, so please read those terms before you pay.
        </p>
      </PolicySection>

      <PolicySection title='How payments are made'>
        <p className='dark-blue fs-6'>
          Our{' '}
          <Link className='text-decoration-none' to='/payments'>tuition and student payments policy</Link>{' '}
          explains how tuition fees, deposits and government fees should be paid, and what we will
          tell you if we are ever authorised to handle a payment on behalf of another organisation.
        </p>
      </PolicySection>
    </PolicyPage>
  )
}

export default Fees
